import { parentPasswordModalActionTypes } from '@/components/modals/parentPasswordModal/Constants';
import { CHECK_PARENT_PASSWORD } from '@/services/Constants';

import {
	ParentPasswordModalAction,
	ParentPasswordModalState,
} from '@/components/modals/parentPasswordModal/types';

const initialState: ParentPasswordModalState = {
	isOpen: false,
	onSuccessPath: null,
	parentPasswordVerificationLoading: false,
	parentPasswordVerificationError: null,
	isParentVerified: !CHECK_PARENT_PASSWORD,
};

const parentPasswordModalReducer = (
	state: ParentPasswordModalState = initialState,
	action: ParentPasswordModalAction,
): ParentPasswordModalState => {
	const { type, payload = {} } = action;

	switch (type) {
		case parentPasswordModalActionTypes.VALIDATE_PARENT_PASSWORD_REQUEST:
			return {
				...state,
				parentPasswordVerificationLoading: true,
				parentPasswordVerificationError: null,
			};

		case parentPasswordModalActionTypes.VALIDATE_PARENT_PASSWORD_SUCCESS:
			return {
				...state,
				parentPasswordVerificationLoading: false,
				isParentVerified: true,
			};

		case parentPasswordModalActionTypes.VALIDATE_PARENT_PASSWORD_ERROR:
			return {
				...state,
				parentPasswordVerificationLoading: false,
				parentPasswordVerificationError: payload.error || null,
			};

		case parentPasswordModalActionTypes.OPEN_PARENT_PASSWORD_MODAL:
			return {
				...state,
				isOpen: true,
				onSuccessPath: payload.onSuccessPath || null,
			};

		case parentPasswordModalActionTypes.CLOSE_PARENT_PASSWORD_MODAL:
			return {
				...state,
				isOpen: false,
			};

		case parentPasswordModalActionTypes.UPDATE_PARENT_VERIFICATION:
			return {
				...state,
				isParentVerified: payload.isVerified ?? state.isParentVerified,
			};

		case parentPasswordModalActionTypes.RESET_PARENT_PASSWORD_VALIDATION:
			return {
				...state,
				parentPasswordVerificationLoading: false,
				isParentVerified: false,
			};

		default:
			return state;
	}
};

export default parentPasswordModalReducer;
